// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"206":"video-system","353":"contact","372":"coupon-mall","374":"zhixing","507":"join","594":"about","671":"services"}[chunkId] + "." + {"206":"03c3bcc7","353":"35c131ce","372":"2509ec9c","374":"5ef85861","507":"77d1ab62","594":"063911ab","671":"abf583b4"}[chunkId] + ".js";
};